export const TipoComprobante = {
    NOTA_ABONO: 'NOTA_ABONO',
    BOLETA: 'BOLETA',
    RECIBO_INGRESO: 'RECIBO_INGRESO'
};

export const TipoComprobanteOptions = [
    { label: 'Nota de Abono', value: TipoComprobante.NOTA_ABONO },
    { label: 'Boleta', value: TipoComprobante.BOLETA },
    { label: 'Recibo de Ingreso', value: TipoComprobante.RECIBO_INGRESO }
];
